<script setup lang="ts">
import { useHead } from '@vueuse/head'
import { useSeo } from '@/composables/useSeo'

const { getSeoHeader } = useSeo()
useHead(getSeoHeader())
</script>

<template>
    <div class="home-view">
        <BaseBanner />
        <CardSection />
    </div>
</template>
